import { useEffect } from "react";
import { Outlet, useParams, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { languages } from "@/i18n";

const validLangCodes = new Set(languages.map((l) => l.code));

/**
 * Wraps all /:lang/* routes.
 * - Validates the lang param
 * - Syncs i18n language from URL
 * - Renders child routes via <Outlet />
 */
export function LanguageLayout() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const { pathname, search, hash } = useLocation();
  const isValid = !!lang && validLangCodes.has(lang);

  // Sync i18n with URL language
  useEffect(() => {
    if (isValid && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem("seaventis-lang", lang);
    }
  }, [lang, i18n, isValid]);

  if (!isValid) {
    // Preserve the full path: /features/fleet → /en/features/fleet
    return <Navigate to={`/en${pathname}${search}${hash}`} replace />;
  }

  return <Outlet />;
}
